import { getAuthenticatedUserData } from '@/api/amplify/helpers';
import { IS_GHOST_ACCOUNT, IS_MOBILE, IS_PROD_ENVIRONMENT } from '@/config/app.config';
import { useUserDataStore } from '@/stores/userDataStore';

declare const window: any;

const isDev = !IS_PROD_ENVIRONMENT;

const track = (eventName, params = {} as any) => {
  if (IS_GHOST_ACCOUNT || isDev) {
    return;
  }

  params.mobile = IS_MOBILE;

  window.analytics.track(eventName, params, {
    context: { groupId: useUserDataStore.getState().appKey },
  });
};

const analyticsIdentify = async (account) => {
  if (IS_GHOST_ACCOUNT || isDev) {
    return;
  }

  const userData = await getAuthenticatedUserData();
  const { name, email } = userData?.attributes || {};

  const { appKey, appUrl, owner } = account;

  const userInformation = {
    email,
    name,
    appKey,
    appUrl,
  };

  window.analytics.identify(owner, userInformation);
};

const group = (appKey, params) => {
  if (IS_GHOST_ACCOUNT || isDev) {
    return;
  }

  window.analytics.group(appKey, params);
};

export { track, analyticsIdentify, group };
